// extracted by mini-css-extract-plugin
export default {"text_body":"NoteBody_text_body__tQ8qv","text_body__text":"NoteBody_text_body__text__mQmJo"};